import React, { useState } from 'react';
import { CheckboxChangeEvent, Col, Form, Layout, notification, Row, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { SiteBranding } from 'parts';
import { Button, Checkbox, Input } from 'components';
import { PAGES } from 'router/constants';
import { postSignIn } from 'fetcher/signin';
import { submitHandoff } from 'fetcher/handoff';
import { DASHBOARD_ORIGIN } from 'config';
import { ReactComponent as IconBack } from 'static/icons/arrow_left.svg';
import './style.scss';

export const SignIn: React.FC = () => {
  const [form] = Form.useForm();
  const [showPassword, setShowPassword] = useState(false);

  const onSubmit = (values: any) => {
    const data = {
      email: values.email,
      password: values.password,
    };
    postSignIn(data)
      .then((resp) => {
        const code = resp?.handoff_code;

        if (!code) {
          // The backend has not deployed SEC-041 yet. Fall back to the legacy
          // token-in-URL redirect so the two repos stay independently deployable
          // in either order.
          // eslint-disable-next-line no-console
          console.warn('Sign-in response carried no handoff_code; falling back to the legacy session redirect.');
          window.location.href = `${DASHBOARD_ORIGIN}/dashboard/${resp.session}`;
          return;
        }

        try {
          // Navigates away from the React app entirely; nothing after this runs.
          submitHandoff(code);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Could not submit the sign-in handoff form', error);
          notification.error({ message: 'Could not complete sign in. Please try again.' });
        }
      })
      .catch(({ detail }) => {
        notification.error({ message: detail });
      });
  };

  return (
    <div className="page-sign-in">
      <Layout className="page-sign-in__content">
        <Row>
          <Col lg={{ flex: '304px' }} md={{ flex: '100%' }} span={24}>
            <SiteBranding />
          </Col>
          <Col className="form-block" lg={{ flex: '1' }} span={24}>
            <Row className="form-block__header">
              <Col span={24}>
                <Typography.Title level={3}>Sign In</Typography.Title>
              </Col>
              <Col span={24}>
                <Typography.Text>As UPSL player or coach </Typography.Text>
              </Col>
            </Row>
            <Form form={form} onFinish={onSubmit} validateTrigger="onBlur" className="form-block__content">
              <Row>
                <Col span={24}>
                  <Input
                    label="Email"
                    name="email"
                    rules={[
                      { required: true, message: 'Enter email' },
                      // { type: 'email', message: 'Invalid email format' },
                    ]}
                  />
                </Col>
                <Col span={24}>
                  <Input
                    className="input-password"
                    label="Password"
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    rules={[{ required: true, message: 'Enter password' }]}
                  />
                </Col>
              </Row>
              <Row justify="space-between">
                <Col>
                  <Checkbox
                    className="input-show-password"
                    name="show-password"
                    onChange={(e: CheckboxChangeEvent) => setShowPassword(e.target.checked)}
                    formItemProps={{ valuePropName: 'checked' }}
                  >
                    Show password
                  </Checkbox>
                </Col>
                <Col>
                  <Link className="reset-link" to={PAGES.PASSWORD_RESET}>
                    Forgot password
                  </Link>
                </Col>
              </Row>
              <Row gutter={8} justify="space-between" className="form-block__footer">
                <Col flex="1">
                  <Link to={PAGES.HOME}>
                    <Button className="back-button" size="large" type="default" icon={<IconBack />} aria-label="Back">
                      <span className="back-button__label">Back</span>
                    </Button>
                  </Link>
                </Col>
                <Col>
                  <Link to="/player-registration">
                    <Button size="large" type="default">
                      Create profile
                    </Button>
                  </Link>
                </Col>
                <Col flex="1" className="form-block__footer-end">
                  <Button size="large" htmlType="submit">
                    Sign In
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Layout>
    </div>
  );
};
